import { SentryError } from '@ifixit/sentry';
import { SearchClientType } from 'Guide/searchClient';

export const multiSearchAlgolia = async <T>(
   searchClient: SearchClientType,
   indexNames: string[],
   query: string,
   maxHits?: number
) => {
   if (!searchClient) {
      throw new SentryError('Algolia search client not set up');
   }
   const promises = indexNames.map<Promise<Array<T>>>(async indexName => {
      const index = searchClient.initIndex(indexName);
      const { hits } = await index.search<T>(query, { hitsPerPage: maxHits });
      return hits;
   });
   const results = await Promise.all(promises);
   const combinedResults = results.flat();
   return maxHits ? combinedResults.slice(0, maxHits) : combinedResults;
};
